import { ResponsiveImage } from '@vcc-package/media';

const Image: React.FC<{
  alt: string;
  src: string;
  title?: string;
}> = ({ alt, src, title }) => {
  const image = { alt, src, title };

  return <ResponsiveImage alt={alt} images={{ sm: image }} loading="lazy" />;
};

export default Image;
